import type { CPU } from '../CPU';
import { PSW_Z, PSW_C } from './constants';

export function opMUL(cpu: CPU): void {
  cpu.impl_operands[0].value &= 0xFF;
  cpu.impl_operands[0].value *= cpu.impl_operands[1].value;

  cpu.impl_flags_changed |= PSW_Z;
  cpu.impl_flags_out = cpu.impl_operands[0].value ? 0 : PSW_Z;
}

export function opDIV(cpu: CPU): void {
  cpu.impl_flags_changed |= PSW_Z | PSW_C;
  if (!cpu.impl_operands[1].value) {
    cpu.impl_flags_out |= PSW_C;
    return;
  }

  const quotient = Math.floor(cpu.impl_operands[0].value / cpu.impl_operands[1].value);
  const remainder = cpu.impl_operands[0].value % cpu.impl_operands[1].value;

  cpu.impl_operands[0].value = quotient;
  if (cpu.impl_operands[0].value)
    cpu.impl_flags_out &= ~PSW_Z;

  const remainder_reg_index = (cpu.impl_opcode >> 4) & 0x000F;
  cpu.regs.r[remainder_reg_index] = remainder;
}
